import { TCNNState } from "state/tree/tcnn";

export default {
  getTopTcnnMessage: (state: TCNNState) => state.queue[0],
  getSelectedTcnnMessage: (state: TCNNState) => state.selectedTCNNMessage,
};
